/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveWishlistSupplierMutationVariables = Exact<{
  companyId: string;
  role_assignment_id: string;
  supplier_id: string;
}>;


export type RemoveWishlistSupplierMutation = { removeWishlistSupplier: { success: boolean } | null };


export const RemoveWishlistSupplierDocument = /*#__PURE__*/ gql`
    mutation RemoveWishlistSupplier($companyId: uuid!, $role_assignment_id: uuid!, $supplier_id: uuid!) {
  removeWishlistSupplier(
    companyId: $companyId
    role_assignment_id: $role_assignment_id
    supplier_id: $supplier_id
  ) {
    success
  }
}
    `;
export type RemoveWishlistSupplierMutationFn = Apollo.MutationFunction<RemoveWishlistSupplierMutation, RemoveWishlistSupplierMutationVariables>;

/**
 * __useRemoveWishlistSupplierMutation__
 *
 * To run a mutation, you first call `useRemoveWishlistSupplierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveWishlistSupplierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeWishlistSupplierMutation, { data, loading, error }] = useRemoveWishlistSupplierMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role_assignment_id: // value for 'role_assignment_id'
 *      supplier_id: // value for 'supplier_id'
 *   },
 * });
 */
export function useRemoveWishlistSupplierMutation(baseOptions?: Apollo.MutationHookOptions<RemoveWishlistSupplierMutation, RemoveWishlistSupplierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveWishlistSupplierMutation, RemoveWishlistSupplierMutationVariables>(RemoveWishlistSupplierDocument, options);
      }
export type RemoveWishlistSupplierMutationHookResult = ReturnType<typeof useRemoveWishlistSupplierMutation>;
export type RemoveWishlistSupplierMutationResult = Apollo.MutationResult<RemoveWishlistSupplierMutation>;
export type RemoveWishlistSupplierMutationOptions = Apollo.BaseMutationOptions<RemoveWishlistSupplierMutation, RemoveWishlistSupplierMutationVariables>;